import React, { useRef, useEffect } from "react";
function withQueryFilter(WrappedComponent, textFilterKeysConfig) {
  return function QueryFilterHoc({
    model,
    onChange,
    availableFilters,
    viewMode,
    defaultFilterString,
    ...props
  }) {
    const {
      model: filterModel,
      onChange: handleChange,
      defaultFilterModel
    } = useQueryFilterHoc({
      model,
      onChange,
      availableFilters,
      textFilterKeysConfig,
      defaultFilterString
    });
    return /* @__PURE__ */ React.createElement(
      WrappedComponent,
      {
        model: filterModel,
        onChange: handleChange,
        availableFilters,
        viewMode,
        defaultFilterModel,
        ...props
      }
    );
  };
}
function useQueryFilterHoc({
  model,
  onChange,
  availableFilters,
  textFilterKeysConfig,
  defaultFilterString
}) {
  const textFilterKey = Object.keys(textFilterKeysConfig ?? {}).find(
    (i) => availableFilters?.map((f) => typeof f === "string" ? f : f.filterName).includes(i)
  );
  const textFilterKeys = textFilterKey ? textFilterKeysConfig?.[textFilterKey] : [];
  const currentFilterModel = useRef(getFilterModel(model));
  const defaultFilterModel = defaultFilterString ? getFilterModel(defaultFilterString) : void 0;
  useEffect(() => {
    currentFilterModel.current = getFilterModel(model);
  }, [model]);
  function handleChange(newValue) {
    const keyValueFilter = Object.entries(newValue)?.flatMap(([key, value]) => {
      let result = [];
      if (key === "text") {
        result = textFilterKeys?.map((k) => value?.option === k ? { key: value?.option, value: value?.text } : { key: k, value: "" });
      } else {
        if (!textFilterKeys.some((t) => t === key)) {
          result = [{ key, value }];
        }
      }
      return result;
    });
    const defaultFilters = getDefaultFilters(keyValueFilter);
    onChange([...keyValueFilter, ...defaultFilters]);
  }
  function getFilterModel(filter) {
    const searchObject = new URLSearchParams(filter);
    const filterModel = {};
    searchObject?.forEach((value, key) => {
      let parsedValue;
      try {
        parsedValue = JSON.parse(value);
      } catch {
        parsedValue = value;
      }
      filterModel[key] = parsedValue;
    });
    const option = textFilterKeys?.find((k) => filterModel?.[k]);
    if (option) {
      filterModel.text = option && filterModel?.[option] ? { option, text: filterModel?.[option] } : void 0;
    }
    return filterModel;
  }
  function getDefaultFilters(newFilters) {
    const updatedModelKeys = newFilters?.map((i) => i.key);
    const currentModelKeys = Object.keys(currentFilterModel.current);
    const unusedKeys = currentModelKeys?.filter((k) => k !== "text" && !updatedModelKeys?.includes(k));
    return unusedKeys?.map((key) => ({
      key,
      value: currentFilterModel.current[key]
    }));
  }
  return { model: currentFilterModel.current, onChange: handleChange, defaultFilterModel };
}
export {
  useQueryFilterHoc,
  withQueryFilter
};
//# sourceMappingURL=QueryFilterHoc.js.map
